import React, { useState, useEffect } from "react";
import SmallScreenSidebar from "../SmallScreenSidebar";
import { AiOutlineBars } from "react-icons/ai";
import { FaCheckCircle } from "react-icons/fa";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { MyContextSupply } from "../../../Context";
import AdminSkeleton from "../AdminSkeleton/AdminSkeleton";
import axios from "axios";
import { toast } from "react-toastify";
import AddressPopUp from "./AddressPopUp";
import SearchOrder from "./SearchOrder";
import FoundOrder from "./FoundOrder";

const AdminRecentOrders = () => {
  const { setIsAdminSidebarOpen, token } = MyContextSupply();
  const [allOrdersData, setAllOrdersData] = useState([]);
  const [isOrderLoading, setIsOrderLoading] = useState(false);
  const [runConfirmData, setRunConfirmData] = useState(0);
  const [shippingData, setShippingData] = useState("");
  const [isShowShipping, setIsShowShipping] = useState(false);
  const [inputsValue, setInputValue] = useState("");
  const [searchOrderIdInput, setSearchOrderIdInput] = useState("");
  console.log(searchOrderIdInput);

  console.log(allOrdersData);

  const toastStyle = {
    position: "top-center",
    autoClose: 2000,
  };

  const getOrdersData = async () => {
    setIsOrderLoading(true);
    await axios
      .get("https://stechbackend-9r4c.onrender.com/get/all/orders/", {
        headers: { Authorization: token },
        withCredentials: true,
      })
      .then((res) => {
        if (res.status === 200) {
          setAllOrdersData(res.data);
          setIsOrderLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // post order confirmation
  const ConfirmedOrder = async (id, userId) => {
    await axios
      .put(
        `https://stechbackend-9r4c.onrender.com/purchase/user/order/confirm/${id}`,
        { userId },
        { headers: { Authorization: token }, withCredentials: true }
      )
      .then((res) => {
        if (res.status === 201) {
          toast.success(res.data.message, toastStyle);
          setRunConfirmData(runConfirmData + 1);
          setSearchOrderIdInput("");
          setInputValue("");
        }
      })
      .catch((error) => {
        const status = error.response.status;
        const message = error.response.data.message;
        if (status === 403) {
          toast.success(message, toastStyle);
        } else if (status === 404) {
          toast.success(message, toastStyle);
        } else if (status === 500) {
          toast.success(message, toastStyle);
        } else {
          toast.success(message, toastStyle);
        }
      });
  };
  useEffect(() => {
    getOrdersData();
  }, [runConfirmData]);
  // console.log(allOrdersData);
  return (
    <section className="main-prod">
      <SmallScreenSidebar />
      <button
        onClick={() => setIsAdminSidebarOpen(true)}
        className="smallsidebar-open-btn"
      >
        <AiOutlineBars />
      </button>
      <div className="deshboard-content-part">
        <h1>User Orders</h1>
        {isOrderLoading ? (
          <AdminSkeleton />
        ) : (
          <section
            className="desh-main-display"
            style={{ background: "white" }}
          >
            <article className="table-article-user">
              <div className="manageOrderTitle-searchOrder">
                <h1>Manage Customers Orders</h1>
                <SearchOrder
                  setSearchOrderIdInput={setSearchOrderIdInput}
                  inputsValue={inputsValue}
                  setInputValue={setInputValue}
                />
              </div>
              {allOrdersData.length === 0 ? (
                <h1>No orders data found</h1>
              ) : (
                <table border="1" style={{ fontWeight: "bolder" }}>
                  <thead>
                    <tr style={{ background: "skyblue" }}>
                      <td>Order Time</td>
                      <td>Order ID</td>
                      <td>Name</td>
                      <td>Shipping Address</td>
                      <td>Total Price($)</td>
                      <td>Delivery Status</td>
                      <td>Delivery</td>
                    </tr>
                  </thead>
                  <tbody>
                    {allOrdersData.map((order) => {
                      const {
                        _id: id,
                        createdAt,
                        isDelivered,
                        totalPrice,
                        userId,
                        shippingDetails: { name },
                      } = order;
                      const localDate = new Date(
                        createdAt
                      ).toLocaleDateString();
                      const localTime = new Date(
                        createdAt
                      ).toLocaleTimeString();
                      return (
                        <tr key={id} className="admin-order-list-table">
                          <td>
                            {localDate}, {localTime}
                          </td>
                          <td>{id}</td>
                          <td>{name}</td>
                          <td>
                            <span
                              onClick={() => {
                                setShippingData(order.shippingDetails);
                                setIsShowShipping(true);
                              }}
                              className="orderShippingAddress"
                            >
                              CHECK
                            </span>
                          </td>
                          <td>{totalPrice}</td>
                          <td>
                            {isDelivered && isDelivered ? (
                              <span className="td-delivery-status deli-success">
                                <FaCheckCircle className="td-del-icon" />
                                Delivered
                              </span>
                            ) : (
                              <span className="td-delivery-status not-deli">
                                <IoMdCloseCircleOutline className="td-del-icon" />
                                Not Delivered
                              </span>
                            )}
                          </td>
                          <td className="td-confirm-btn-width-fixed">
                            {isDelivered ? (
                              <span style={{ color: "green" }}>Confirmed</span>
                            ) : (
                              <p
                                className="order-confirm-btn-td"
                                onClick={() => ConfirmedOrder(id, userId)}
                              >
                                Confirm Now
                              </p>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </article>
          </section>
        )}
      </div>
      <AddressPopUp
        isShowShipping={isShowShipping}
        setIsShowShipping={setIsShowShipping}
        shippingData={shippingData}
      />
      {searchOrderIdInput && (
        <FoundOrder
          allOrdersData={allOrdersData}
          searchOrderIdInput={searchOrderIdInput}
          setInputValue={setInputValue}
          setSearchOrderIdInput={setSearchOrderIdInput}
          setShippingData={setShippingData}
          setIsShowShipping={setIsShowShipping}
          ConfirmedOrder={ConfirmedOrder}
        />
      )}
    </section>
  );
};

export default AdminRecentOrders;
